import { useCallback } from 'react';
import { getSoftpayReceipt } from '@ordr-as/ordr-service-types/epos';
import config from '../config';

const useSoftpayReceipt = () =>
  useCallback(async (paymentReference: string) => {
    const receiptData = await getSoftpayReceipt(paymentReference);

    const receiptDataJson = encodeURIComponent(receiptData.receipt.join(','));
    const url = `${config.receiptUrl}/${paymentReference}`;

    const intentURL = `intent://favritsoftpay#Intent;scheme=favritsoftpay;package=com.favrit.favritsoftpay;action=android.intent.action.VIEW;S.type="RECEIPT";S.json={"url": "${url}", "data": "${receiptDataJson}"};end`;

    window.location.href = intentURL;
  }, []);
export default useSoftpayReceipt;
